export const ORDER_TYPE = {
  VEHICLE_INSPECTION: {
    value: 1,
    label: "orderType.VEHICLE_INSPECTION",
  },
  AUTO_NOTIFY_VIOLATION: {
    value: 2,
    label: "orderType.AUTO_NOTIFY_VIOLATION",
  },
  REVIEW_TIP: {
    value: 3,
    label: "orderType.REVIEW_TIP",
  },
  TEST: {
    value: 4,
    label: "orderType.TEST",
  },
  INSURANCE_MOTORBIKE_TNDSBB: {
    value: 6,
    label: "orderType.INSURANCE_MOTORBIKE_TNDSBB",
  },
  INSURANCE_CAR_TNDSBB: {
    value: 7,
    label: "orderType.INSURANCE_CAR_TNDSBB",
  },
  INSURANCE_CAR_BHTV: {
    value: 8,
    label: "orderType.INSURANCE_CAR_BHTV",
  },
};

export const stations_location = [
  { value: 0, key: 'newOrders', label: "orderStatus.pending", color: "#10b981" },
  { value: 10, key: 'acceptedOrders', label: "orderStatus.accepted", color: "#10b981" },
  { value: 20, key: 'canceledOrders', label: "orderStatus.rejected", color: "#ef4444" },
  { value: 30, key: 'closedOrders', label: "orderStatus.completed", color: "#60a5fa" },
];

export const ORDER_PAYMENT_STATUS = [
  { value: "New", label: "orderPaymentStatus.new", color: "text-warning" },
  {
    value: "Processing",
    label: "orderPaymentStatus.processing",
    color: "text-warning",
  },
  { value: "Pending", label: "orderPaymentStatus.pending", color: "text-processing" },
  { value: "Failed", label: "orderPaymentStatus.failed", color: "text-error" },
  {
    value: "Success",
    label: "orderPaymentStatus.success",
    color: "text-success",
  },
  // { value: "Canceled", label: "orderPaymentStatus.canceled", color: "text-error" },
];

export const AFFILIATE_ORDER_STATUS = [
  { value: 0, label: "affiliate.orderStatus.new", color: "text-warning" },
  { value: 10, label: "affiliate.orderStatus.confirmed", color: "text-primary" },
  { value: 20, label: "affiliate.orderStatus.canceled", color: "text-danger" },
  { value: 30, label: "affiliate.orderStatus.closed", color: "text-secondary" },
  { value: 40, label: "affiliate.orderStatus.processing", color: "text-processing" },
];

// Mapping payment method IDs (from API) to display text
export const PAYMENT_METHOD_LABEL = {
  0: 'Thanh toán qua tiền mặt',
  1: 'Thanh toán qua ngân hàng',
  2: 'Thanh toán qua VietQR Interprise',
  3: 'Thanh toán qua MOMO',
  4: 'Thanh toán qua Gtelpay',
  5: 'Thanh toán qua Zalopay',
  6: 'Thanh toán qua TAMove',
  7: 'Thanh toán qua VNPAY',
  8: 'Thanh toán qua sepay',
  11: 'Thanh toán qua Bảo Kim',
  12: 'Thanh toán qua Kim Ngân',
  13: 'Thanh toán qua VNPAY InApp',
};

export const PAYMENT_METHOD_TYPE = {
  ATM_BANK: 1,
  MOMO: 2,
  GTELPAY: 3,
  VNPAY: 4,
  ZALOPAY: 5,
  VIETTEL_PAY: 6,
};


export const INSURANCE_CAR_TYPE_LABEL_BY_SUB_TYPE = {
  1: "Dưới 6 chỗ ngồi",
  2: "6-11 chỗ ngồi",
  10: "Xe chuyên dụng",
  11: "6-11 chỗ ngồi",
  12: "Xe chở hàng",
  14: "Xe vừa chở người, vừa chở hàng (Pickup, minivan)",
};

export const SPECIAL_TRANSPORT_LABEL = {
  1: "Xe cứu thương",
  2: "Xe chở tiền",
};


// Payment methods with colors for charts
export const PAYMENT_METHODS = {
  "0": {
    label: 'Tiền mặt',
    color: "#10b981",
    paymentMethodId: 0,
    paymentMethodType: 0,
  },
  "1": {
    label: 'VietQR',
    color: "#fbbf24",
    paymentMethodId: 2,
    paymentMethodType: 1,
  },
  "2": {
    label: 'MOMO',
    color: "#60a5fa",
    paymentMethodId: 3,
    paymentMethodType: 2,
  },
  "3": {
    label: 'Gtelpay',
    color: "#ef4444",
    paymentMethodId: 4,
    paymentMethodType: 3,
  },
  "4": {
    label: 'VNPAY',
    color: "#2563eb",
    paymentMethodId: 7,
    paymentMethodType: 4,
  },
  "5": {
    label: 'ZalopayQR',
    color: "#d97706",
    paymentMethodId: 5,
    paymentMethodType: 5,
  },
  "10": {
    label: 'ShopeePay',
    color: "#f97316",
    paymentMethodId: 10,
    paymentMethodType: 10,
  },
  "11": {
    label: 'Bảo Kim',
    color: "#047857",
    paymentMethodId: 11,
    paymentMethodType: 11,
  },
   "12": {
    label: 'Kim Ngân',
    color: "#0ea5e9",
    paymentMethodId: 12,
    paymentMethodType: 12,
  },
  "13": {
    label: 'VNPAY InApp',
    color: "#1d4ed8",
    paymentMethodId: 13,
    paymentMethodType: 13,
  },
};

// Product categories with labels and colors for charts
export const PRODUCT_CATEGORIES = {
  0: { label: 'Khác', color: "#10b981" },
  1: { label: 'Ưu đãi', color: "#fbbf24" },
  2: { label: 'Zalo', color: "#3a78ffff" },
  3: { label: 'SMS', color: "#f59e0b" },
  4: { label: 'Email', color: "#06b6d4" },
  5: { label: 'Tip', color: "#e494a8ff" },
  6: { label: 'Bảo hiểm xe máy', color: "#ef4444" },
  7: { label: 'Bảo hiểm ô tô TNDSBB', color: "#14349bff" },
  8: { label: 'Bảo hiểm ô tô BHTV', color: "#8b5cf6" },
  9: { label: 'Thông báo vi phạm', color: "#828282ff" },
};

export const PRODUCT_PROVIDER = {
  ALL: { providerName: "Tất cả", providerCode: "ALL" },
  MOMO: { providerName: "MoMo", providerCode: "MOMO", productCategory: [9] },
  TAMOVE: { providerName: "Tamove", providerCode: "TAMOVE", productCategory: [1, 2, 3, 4, 5] },
  TTDK: { providerName: "TTDK", providerCode: "TTDK", productCategory: [1, 2, 3, 4, 5] },
  VIETTEL_MONEY: { providerName: "Viettel Money", providerCode: "VIETTEL_MONEY", productCategory: [9] },
  VNPAY: { providerName: "VNPAY", providerCode: "VNPAY", productCategory: [9] },
  WIIGO: { providerName: "Wiigo", providerCode: "WIIGO", productCategory: [9] },
  ZALO_PAY: { providerName: "ZaloPay", providerCode: "ZALO_PAY", productCategory: [9] },
  BAOMINH: { providerName: "Bảo hiểm Bảo Minh", providerCode: "BAOMINH", productCategory: [7] },
  BIC: { providerName: "Bảo hiểm BIC", providerCode: "BIC", productCategory: [7] },
  BSH: { providerName: "Bảo hiểm BSH", providerCode: "BSH", productCategory: [7] },
  DIGIIN: { providerName: "Bảo hiểm Digiin", providerCode: "DIGIIN", productCategory: [7] },
  MIC: { providerName: "Bảo hiểm MIC", providerCode: "MIC", productCategory: [7, 6] },
  PVI: { providerName: "Bảo hiểm PVI", providerCode: "PVI", productCategory: [7] },
  SALADIN: { providerName: "Bảo hiểm Saladin", providerCode: "SALADIN", productCategory: [7] },
  VNI: { providerName: "Bảo hiểm VNI", providerCode: "VNI", productCategory: [7] },
};
